import MainBanner from './MainBanner';

export default MainBanner;
